import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUser, hasRole } from '../../_hooks';
import Loading from './loading';

/**
 * Protège une route selon les rôles requis.
 * Passer tous les rôles autorisés explicitement (hiérarchie non inférée).
 * Ex : ['ROLE_RDG', 'ROLE_AGENT_GRDF']
 */
function RequiredRole({ allowedRoles }) {
    const user = useUser();

    if (!user) {
        return <Loading />;
    }

    const hasAccess = allowedRoles.some((role) => hasRole(user, role));

    if (!hasAccess) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
}

export default RequiredRole;
